
import { CategoryDefinition } from "@/types/habit";

export const REWARD_IMAGES: Record<string, string> = {
  "book": "/lovable-uploads/book-reward.png",
  "movie": "/lovable-uploads/movie-reward.png",
  "game": "/lovable-uploads/game-reward.png",
  "food": "/lovable-uploads/food-reward.png",
  "coffee": "/lovable-uploads/coffee-reward.png",
  "shopping": "/lovable-uploads/shopping-reward.png",
  "music": "/lovable-uploads/music-reward.png",
  "travel": "/lovable-uploads/travel-reward.png"
};

export const CATEGORIES: CategoryDefinition[] = [
  {
    name: "Mind & Meditation",
    description: "Mental wellness and mindfulness practices"
  },
  {
    name: "Fitness",
    description: "Physical exercise and workout routines"
  },
  {
    name: "Health",
    description: "General health and wellness habits"
  },
  {
    name: "Learning",
    description: "Educational and skill development"
  },
  {
    name: "Arts & Music",
    description: "Creative and artistic pursuits"
  },
  {
    name: "Travel",
    description: "Travel and adventure activities"
  },
  {
    name: "Lifestyle",
    description: "Daily routines and lifestyle improvements"
  },
  {
    name: "Nature",
    description: "Outdoor and environmental activities"
  },
  {
    name: "Creativity",
    description: "Creative projects and expression"
  },
  {
    name: "Sports",
    description: "Sports and athletic activities"
  }
];
